module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/icons-chrome-desaturated-e736fcc31df0ea8b3451357a9579ab61.svg";